<template>
	<vs-table class="mt-4 w-full" noDataText="">
		<template slot="thead">
			<vs-th></vs-th>
			<vs-th class="white-txt"
				><div class="w-full text-right">
					{{
						getMonthFrench(today.getMonth() - 2).toUpperCase() +
						" " +
						getYearFromMonth(today.getMonth() - 2)
					}}
				</div></vs-th
			>
			<vs-th class="white-txt tr2"
				><div class="w-full text-right">
					{{
						getMonthFrench(today.getMonth() - 1).toUpperCase() +
						" " +
						getYearFromMonth(today.getMonth() - 1) +
						"　"
					}}
				</div></vs-th
			>
			<vs-th class="white-txt" style="width: 130px"
				><div class="layer-blue"><div></div></div>
				<div
					class="w-full text-right text-white"
					style="padding-right: 20px; z-index: 998"
				>
					{{
						getMonthFrench(today.getMonth()).toUpperCase() +
						" " +
						getYearFromMonth(today.getMonth())
					}}
				</div></vs-th
			>
		</template>

		<template>
			<vs-tr class="noHover" style="background: transparent">
				<vs-td style="font-weight: 500; padding-left: 20px !important"
					><div style="width: 50px">Accomplissement</div></vs-td
				>
				<vs-td class="text-right" style="font-weight: 500; padding-right: 12px"
					>{{ lastLastMonthTaskDone
					}}<span style="color: #08b0b9">
						/ {{ lastLastMonthTaskTotal }}</span
					></vs-td
				>
				<vs-td class="text-right tr2" style="font-weight: 500"
					><div style="padding-right: 20px">
						{{ lastMonthTaskDone
						}}<span style="color: #08b0b9"> / {{ lastMonthTaskTotal }}</span>
					</div></vs-td
				>
				<vs-td class="text-right" style="padding-right: 32px"
					><div style="color: white; position: relative; z-index: 999">
						{{ currentTaskDone
						}}<span style="color: #08b0b9"> / {{ currentTaskTotal }}</span>
					</div></vs-td
				>
			</vs-tr>
		</template>
	</vs-table>
</template>

<script>
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import utilsMixin from "@/mixins/utilsMixin";
import tasksMixin from "@/mixins/tasksMixin";
import store from "@/store/store";

export default {
	name: "TaskMonitoringTable",
	props: {
		contract: Object,
		thisTasks: Array,
	},
	mixins: [dbFieldConvertor, utilsMixin, tasksMixin],
	computed: {
		today: () => {
			return new Date(Date.now());
		},
		tasks: () => {
			return store.state.tasks;
		},
	},
	data() {
		return {
			currentTaskTotal: 0,
			currentTaskDone: 0,
			lastMonthTaskTotal: 0,
			lastMonthTaskDone: 0,
			lastLastMonthTaskTotal: 0,
			lastLastMonthTaskDone: 0,
			currentMonthTasks: [],
			lastMonthTasks: [],
			lastLastMonthTasks: [],
		};
	},
	watch: {
		"$props.thisTasks": function () {
			this.refreshTasks();
		},
	},
	created() {
		this.refreshTasks();
	},
	methods: {
		refreshTasks() {
			let currentTasks = this.getMonthTasks(
				this.getYearFromMonth(this.today.getMonth()),
				this.today.getMonth() + 1,
				this.contract.id,
				this.$props.thisTasks
			);
			this.currentMonthTasks = currentTasks.tasks;
			this.currentTaskDone = currentTasks.done;
			this.currentTaskTotal = this.currentMonthTasks.length;

			let lastTasks = this.getMonthTasks(
				this.getYearFromMonth(this.today.getMonth() - 1),
				this.getSubstractedMonth(this.today.getMonth(), 1),
				this.contract.id,
				this.$props.thisTasks
			);
			this.lastMonthTasks = lastTasks.tasks;
			this.lastMonthTaskDone = lastTasks.done;
			this.lastMonthTaskTotal = this.lastMonthTasks.length;

			let lastLastTasks = this.getMonthTasks(
				this.getYearFromMonth(this.today.getMonth() - 2),
				this.getSubstractedMonth(this.today.getMonth(), 2),
				this.contract.id,
				this.$props.thisTasks
			);
			this.lastLastMonthTasks = lastLastTasks.tasks;
			this.lastLastMonthTaskDone = lastLastTasks.done;
			this.lastLastMonthTaskTotal = this.lastLastMonthTasks.length;
		},
		getYearFromMonth(month) {
			let year =
				month >= 0 ? this.today.getFullYear() : this.today.getFullYear() - 1;
			return year.toString().substring(0, 4);
		},
	},
};
</script>

<style scoped>
.layer-blue {
	display: block;
	position: absolute;
	border-radius: 10px;
	margin-right: 20px;
	right: 0;
	top: 0;
	width: 25%;
	height: 200%;
	background-color: rgba(12, 41, 61, 0.9);
}
.layer-blue > div {
	display: block;
	position: absolute;
	width: 100%;
	height: 50%;
	border-radius: 10px;
	background-color: #0c293d;
}

.center {
	justify-content: center;
}

.noHover > * {
	pointer-events: none;
}

.b-border {
	border-bottom: 2px solid grey;
}

.r-border {
	border-right: 2px solid grey;
}
.bgcolor {
	background-color: #383080;
}
.white-txt {
	color: white;
}
</style>
